/* eslint-disable no-use-before-define */
import { takeLatest, select } from 'redux-saga/effects';

import generateImagePreview from '../../../utils/generateImagePreview';
import { IMAGE_PREVIEW_WIDTH } from '../../../constants/chat';
import { authTokenSelector } from '../../auth/selectors';

import getFakeUploadAttachmentMessage from '../helpers/getFakeUploadAttachmentMessage';
import { chatModuleInstanceSelector } from '../selectors';
import chatConsts from '../constants';
import actions from '../actions';

function* uploadAttachmentWorker({ dispatch }, action) {
  const state = yield select();

  const { uploader } = chatModuleInstanceSelector(state);

  const authToken = authTokenSelector(state);

  const {
    files,
    message: messageText,
    teamId,
    channel,
    important,
    teamUserId,
    inboxTaskId,
    quoteMessageId,
  } = action.payload;
  const { channelId } = channel;
  const attachments = [];

  const message = getFakeUploadAttachmentMessage(channelId, 'files');

  const credentials = {
    channelId,
    id: message.id,
  };

  const fetchMessages = params => dispatch(actions.fetchMessages(params));

  const clearUpload = () =>
    dispatch(actions.removeUploadAttachment(credentials));

  const updateUpload = params =>
    dispatch(
      actions.updateAttachmentUploadStatus({
        ...credentials,
        ...params,
      }),
    );

  updateUpload({
    cancel: () => {
      uploadTask();
      clearUpload();
      fetchMessages(channel);
    },
    progress: 0,
    message,
  });

  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    const attachedPreview = file.type.includes('image')
      ? yield generateImagePreview(file, false, IMAGE_PREVIEW_WIDTH)
      : null;

    const attachmentData = {
      attachment: file,
    };

    if (attachedPreview) {
      attachmentData.preview = attachedPreview;
    }

    attachments.push(attachmentData);
  }

  const uploadTask = uploader.upload({
    token: authToken,
    teamId,
    teamUserId,
    channelId,
    attachments,
    important,
    inboxTaskId,
    quoteMessageId,
    message: messageText,
    onSuccess: clearUpload,
    onError: () => updateUpload({ error: true }),
    onProgress: e =>
      updateUpload({ progress: Math.round((e.loaded / e.total) * 100) }),
  });

  fetchMessages(channel);
}

export default function* uploadAttachmentSaga(...args) {
  yield takeLatest(
    [chatConsts.UPLOAD_ATTACHMENT],
    uploadAttachmentWorker,
    ...args,
  );
}



// WEBPACK FOOTER //
// ./src/redux/chatConnection/sagas/uploadAttachment.js